import { Flex } from "../../components/Flex";
import { Paragraph } from "../../components/Paragraph";
import { Box } from "../../components/Box";
import { DetailField } from "../../components/DetailField";
import CustomTabs from "../../components/CustomTabs";
import Employment from "./Employment";
import SourceOfFundsCard from "./SourceOfFunds";
import { ApplicationForms } from "./ApplicationForms";
import { Geolocation } from "../../components/Geolocation";
import { DateTime } from "luxon";
import {
  Heading,
  TitleHeading,
  CardLine,
  isProvided,
  formatAddressDate,
  joinAddressParts,
} from "./styles";

export const EntityOverviewTab = ({
  individual,
  setShowAddNewForm,
  entityDetailCountryName,
  entityDetailTypeName,
}: {
  individual: any;
  setShowAddNewForm: (value: boolean) => void;
  entityDetailCountryName: string;
  entityDetailTypeName: string;
}) => {
  return (
                          <CustomTabs
                            variant="segmented"
                            tabs={[
                              {
                                label: "Invite",
                                content: (
                                  <div>
                                    <TitleHeading mb={2}>
                                      Invite Details
                                    </TitleHeading>
                                    <Flex gap="24">
                                      <DetailField
                                        flex={1}
                                        label="Name"
                                        value={individual?.company_name}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Type"
                                        value={individual?.entity_type?.name}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Registration number"
                                        value={individual?.registration_number}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Country"
                                        value={individual?.country?.name}
                                      />
                                    </Flex>
                                    <Flex gap="24" mt={2}>
                                      <DetailField
                                        flex={1}
                                        label="Status"
                                        value={
                                          individual?.company_status?.status
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Date of registration"
                                        value={
                                          individual?.date_of_incorporation
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Dissolution date"
                                        value={individual?.dissolution_date}
                                      />
                                      <Box flex={1}></Box>
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Details",
                                content: (
                                  <div>
                                    <TitleHeading mb={2}>
                                      Entity Details
                                    </TitleHeading>

                                    <Flex gap="24">
                                      <DetailField
                                        flex={1}
                                        label="Name"
                                        value={
                                          individual?.personal_detail
                                            ?.company_name
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Type"
                                        value={entityDetailTypeName}
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Registration Number"
                                        value={
                                          individual?.personal_detail
                                            ?.registration_number
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Country"
                                        value={entityDetailCountryName}
                                      />
                                    </Flex>
                                    <Flex gap="24" mt={2}>
                                      <DetailField
                                        flex={1}
                                        label="Status"
                                        value={
                                          individual?.company_status?.status
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Date of registration"
                                        value={
                                          individual?.personal_detail
                                            ?.date_of_incorporation
                                            ? DateTime.fromISO(
                                                individual.personal_detail
                                                  .date_of_incorporation,
                                              ).toFormat("dd/MM/yyyy")
                                            : "-"
                                        }
                                      />
                                      <DetailField
                                        flex={1}
                                        label="Dissolution date"
                                        value={individual?.dissolution_date}
                                      />
                                      <Box flex={1}></Box>
                                    </Flex>
                                    <Flex gap="24">
                                      <Box flex={1} paddingTop={2}>
                                        <Heading mb={2}>
                                          Previous Name(s)
                                        </Heading>
                                        <Flex
                                          gap="24"
                                          fontSize={1}
                                          color="gray.60"
                                          fontFamily={"'Inter', sans-serif"}
                                        >
                                          {individual?.former_name?.length ? (
                                            individual?.former_name?.map(
                                              ({ name, change_date }, i) => (
                                                <Box flex={1} mb={2} key={i}>
                                                  <CardLine>{name}</CardLine>
                                                  <Heading>
                                                    {change_date && (
                                                      <CardLine color="gray.40">
                                                        From{" "}
                                                        {change_date
                                                          ? DateTime.fromISO(
                                                              change_date,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )
                                                          : "-"}
                                                      </CardLine>
                                                    )}
                                                  </Heading>
                                                </Box>
                                              ),
                                            )
                                          ) : (
                                            <CardLine>
                                              No former names provided.
                                            </CardLine>
                                          )}

                                          {individual?.former_name?.length ===
                                            2 && (
                                            <>
                                              <Box flex={1} mb={2}></Box>
                                              <Box flex={1} mb={2}></Box>
                                            </>
                                          )}
                                          {individual?.former_name?.length ===
                                            3 && <Box flex={1} mb={2}></Box>}
                                        </Flex>
                                      </Box>
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Addresses",
                                content: (
                                  <div>
                                    <Flex gap="24">
                                      <Box flex={1}>
                                        {individual?.address && (
                                          <Box mb={2}>
                                            <TitleHeading>
                                              Registered Address
                                            </TitleHeading>
                                            {individual?.address ? (
                                              <>
                                                <Flex gap="24">
                                                  <Box flex={1}>
                                                    <CardLine>
                                                      {joinAddressParts([
                                                        individual?.address
                                                          ?.flat_appartment_subbuilding,
                                                        individual?.address
                                                          ?.building_number,
                                                        individual?.address
                                                          ?.building_name,
                                                        individual?.address
                                                          ?.road_street,
                                                      ])}
                                                    </CardLine>
                                                    <CardLine>
                                                      {joinAddressParts([
                                                        individual?.address
                                                          ?.town_city,
                                                        individual?.address
                                                          ?.district,
                                                      ])}
                                                    </CardLine>
                                                    <CardLine>
                                                      {isProvided(
                                                        individual?.address
                                                          ?.post_zip_code,
                                                      )
                                                        ? individual?.address
                                                            ?.post_zip_code
                                                        : "Not provided"}
                                                    </CardLine>
                                                  </Box>
                                                  <Box flex={1}>
                                                    <Flex
                                                      gap="8"
                                                      alignItems={"center"}
                                                      mb={1}
                                                      fontSize={1}
                                                      color="gray.60"
                                                      fontFamily={
                                                        "'Inter', sans-serif"
                                                      }
                                                    >
                                                      {individual?.address
                                                        ?.country_flag && (
                                                        <Box
                                                          backgroundColor={
                                                            "gray.10"
                                                          }
                                                          borderRadius={"50%"}
                                                          p={"1"}
                                                        >
                                                          <img
                                                            src={`data:image/png;base64,${individual?.address?.country_flag}`}
                                                            alt="iamge"
                                                          />
                                                        </Box>
                                                      )}
                                                      {isProvided(
                                                        individual?.address
                                                          ?.country_name,
                                                      ) && (
                                                        <span>
                                                          &nbsp;
                                                          {
                                                            individual?.address
                                                              ?.country_name
                                                          }
                                                        </span>
                                                      )}
                                                    </Flex>
                                                  </Box>
                                                  <Box flex={1}>
                                                    {isProvided(
                                                      individual?.address
                                                        ?.date_from,
                                                    ) && (
                                                      <Box p={"1"}>
                                                        <CardLine>
                                                          From &nbsp;
                                                          {formatAddressDate(
                                                            individual?.address
                                                              ?.date_from,
                                                          )}
                                                          {isProvided(
                                                            individual?.address
                                                              ?.date_to,
                                                          ) && (
                                                            <>
                                                              &nbsp; to &nbsp;{" "}
                                                              {formatAddressDate(
                                                                individual
                                                                  ?.address
                                                                  ?.date_to,
                                                              )}
                                                            </>
                                                          )}
                                                        </CardLine>
                                                      </Box>
                                                    )}
                                                  </Box>
                                                  <Box flex={1}></Box>
                                                </Flex>
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </Box>
                                        )}

                                        {individual?.previous_address && (
                                          <Box mb={2}>
                                            <Heading>
                                              Additional Addresses
                                            </Heading>
                                            {individual?.previous_address &&
                                            individual?.previous_address
                                              ?.length > 0 ? (
                                              <>
                                                {individual?.previous_address?.map(
                                                  (prevAddress, i) => (
                                                    <Box key={i}>
                                                      <Heading
                                                        style={{ fontSize: 14 }}
                                                      >
                                                        Operating Address{" "}
                                                        {i + 1}
                                                      </Heading>
                                                      <Flex gap="24">
                                                        <Box mb={2} flex={1}>
                                                          <CardLine>
                                                            {prevAddress?.flat_appartment_subbuilding && (
                                                              <span>
                                                                {
                                                                  prevAddress?.flat_appartment_subbuilding
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {prevAddress?.building_number && (
                                                              <span>
                                                                {
                                                                  prevAddress?.building_number
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {prevAddress?.building_name && (
                                                              <span>
                                                                {
                                                                  prevAddress?.building_name
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {
                                                              prevAddress?.road_street
                                                            }
                                                          </CardLine>

                                                          <CardLine>
                                                            {prevAddress?.town_city && (
                                                              <span>
                                                                {
                                                                  prevAddress?.town_city
                                                                }
                                                                &nbsp;
                                                              </span>
                                                            )}
                                                            {
                                                              prevAddress?.district
                                                            }
                                                            ,{" "}
                                                            {
                                                              prevAddress?.post_zip_code
                                                            }
                                                          </CardLine>

                                                          <CardLine>
                                                            {DateTime.fromISO(
                                                              prevAddress?.date_from,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )}{" "}
                                                            -{" "}
                                                            {DateTime.fromISO(
                                                              prevAddress?.date_to,
                                                            ).toFormat(
                                                              "dd/MM/yyyy",
                                                            )}
                                                          </CardLine>
                                                        </Box>
                                                        <Box flex={1}>
                                                          <Flex
                                                            gap="8"
                                                            alignItems={
                                                              "center"
                                                            }
                                                            mb={1}
                                                            fontSize={1}
                                                            color="gray.60"
                                                            fontFamily={
                                                              "'Inter', sans-serif"
                                                            }
                                                          >
                                                            {prevAddress?.country_flag && (
                                                              <Box
                                                                backgroundColor={
                                                                  "gray.10"
                                                                }
                                                                borderRadius={
                                                                  "50%"
                                                                }
                                                                p={"1"}
                                                              >
                                                                <img
                                                                  src={`data:image/png;base64,${prevAddress?.country_flag}`}
                                                                  alt="iamge"
                                                                />
                                                              </Box>
                                                            )}
                                                            {prevAddress?.country_flag && (
                                                              <span>
                                                                &nbsp;
                                                                {
                                                                  prevAddress?.country_name
                                                                }
                                                              </span>
                                                            )}
                                                          </Flex>
                                                        </Box>
                                                        <Box flex={1}>
                                                          {individual?.previous_address && (
                                                            <Box p={"1"}>
                                                              <CardLine>
                                                                {" "}
                                                                From &nbsp;
                                                                {
                                                                  individual
                                                                    ?.address
                                                                    ?.date_from
                                                                }
                                                                {individual
                                                                  ?.address
                                                                  ?.date_to && (
                                                                  <>
                                                                    &nbsp; to
                                                                    &nbsp;{" "}
                                                                    {
                                                                      individual
                                                                        ?.address
                                                                        ?.date_to
                                                                    }
                                                                  </>
                                                                )}
                                                              </CardLine>
                                                            </Box>
                                                          )}
                                                        </Box>
                                                        <Box flex={1}></Box>
                                                      </Flex>
                                                    </Box>
                                                  ),
                                                )}
                                              </>
                                            ) : (
                                              "-"
                                            )}
                                          </Box>
                                        )}
                                      </Box>
                                    </Flex>
                                    <Flex gap="24">
                                      {individual?.geo_location?.lat != null &&
                                        individual?.geo_location?.long !=
                                          null &&
                                        individual?.geo_location
                                          ?.location_service_permitted && (
                                          <>
                                            <Box flex={1}>
                                              <Heading>Geolocation</Heading>
                                              <Flex gap="24">
                                                <Box flex={1}>
                                                  <CardLine>Latitude</CardLine>
                                                  <CardLine>
                                                    {individual?.geo_location
                                                      ?.lat
                                                      ? individual?.geo_location
                                                          ?.lat
                                                      : "-"}
                                                  </CardLine>
                                                </Box>
                                                <Box flex={1}>
                                                  <CardLine>Longitude</CardLine>
                                                  <CardLine>
                                                    {individual?.geo_location
                                                      ?.long
                                                      ? individual?.geo_location
                                                          ?.long
                                                      : "-"}
                                                  </CardLine>
                                                </Box>
                                                <Box flex={1}>
                                                  <CardLine paddingLeft={"1"}>
                                                    Country
                                                  </CardLine>
                                                  <Flex
                                                    gap="8"
                                                    alignItems={"center"}
                                                    mb={1}
                                                    pl={"1"}
                                                    fontSize={1}
                                                    color="gray.60"
                                                    fontFamily={
                                                      "'Inter', sans-serif"
                                                    }
                                                  >
                                                    {individual?.geo_location
                                                      ?.country_flag ? (
                                                      <Box
                                                        backgroundColor={
                                                          "gray.10"
                                                        }
                                                        borderRadius={"50%"}
                                                        p={"1"}
                                                      >
                                                        <img
                                                          src={`data:image/png;base64,${individual?.geo_location?.country_flag}`}
                                                          alt="iamge"
                                                        />
                                                      </Box>
                                                    ) : (
                                                      "-"
                                                    )}
                                                    {individual?.geo_location
                                                      ?.country_flag && (
                                                      <span>
                                                        &nbsp;
                                                        {
                                                          individual
                                                            ?.geo_location
                                                            ?.country_name
                                                        }
                                                      </span>
                                                    )}
                                                  </Flex>
                                                </Box>
                                                <Box flex={1}></Box>
                                              </Flex>

                                              <br />
                                              <Box height="170px" flex={1}>
                                                <Geolocation
                                                  lat={
                                                    individual?.geo_location
                                                      ?.lat
                                                  }
                                                  long={
                                                    individual?.geo_location
                                                      ?.long
                                                  }
                                                />
                                              </Box>
                                            </Box>
                                          </>
                                        )}
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Nature of business",
                                content: (
                                  <div>
                                    <Flex gap="24">
                                      {individual?.nature_of_business ? (
                                        <Box flex={1.4}>
                                          <TitleHeading>
                                            Nature of business
                                          </TitleHeading>
                                          <CardLine style={{ marginTop: "2%" }}>
                                            Business description
                                          </CardLine>
                                          <Paragraph>
                                            {" "}
                                            {
                                              individual?.nature_of_business
                                                ?.description
                                            }
                                          </Paragraph>
                                          {individual?.nature_of_business
                                            ?.industry ? (
                                            <Flex gap="24">
                                              <Box flex={1}>
                                                <CardLine mt={1}>
                                                  Industry
                                                </CardLine>
                                                {individual?.nature_of_business
                                                  ?.industry?.length
                                                  ? individual?.nature_of_business?.industry?.map(
                                                      ({ name, id }, i) => (
                                                        <Box
                                                          flex={1}
                                                          mb={2}
                                                          key={i}
                                                        >
                                                          <Paragraph>
                                                            {id} - {name}
                                                            &nbsp;
                                                          </Paragraph>
                                                        </Box>
                                                      ),
                                                    )
                                                  : ""}
                                              </Box>
                                            </Flex>
                                          ) : (
                                            "-"
                                          )}
                                          {individual?.nature_of_business
                                            ?.sector ? (
                                            <Flex gap="24">
                                              <Box flex={1}>
                                                <Paragraph mt={1}>
                                                  Sectors
                                                </Paragraph>
                                                <CardLine>
                                                  Sectors entity operates in
                                                </CardLine>
                                                {individual?.nature_of_business
                                                  ?.sector?.length
                                                  ? individual?.nature_of_business?.sector?.map(
                                                      ({ name }, i) => (
                                                        <Box
                                                          flex={1}
                                                          mb={2}
                                                          key={i}
                                                        >
                                                          <Paragraph>
                                                            {name}
                                                            &nbsp;
                                                          </Paragraph>
                                                        </Box>
                                                      ),
                                                    )
                                                  : ""}
                                              </Box>
                                            </Flex>
                                          ) : (
                                            ""
                                          )}
                                        </Box>
                                      ) : (
                                        <Paragraph fontSize={1} color="gray.60" my={0}>
                                          This section is not included in your
                                          application process.
                                        </Paragraph>
                                      )}
                                    </Flex>
                                    <Box my={2}>
                                      <Employment
                                        employmentDetails={
                                          individual?.employment_detail
                                        }
                                      />
                                    </Box>
                                    <Box my={2}>
                                      <SourceOfFundsCard
                                        sourceOfFundsDetails={
                                          individual?.source_of_funds
                                        }
                                      />
                                    </Box>
                                  </div>
                                ),
                              },
                              {
                                label: "Parties",
                                content: (
                                  <div>
                                    <Flex gap="24">
                                      {individual?.parties ? (
                                        <Box flex={1.4}>
                                          <TitleHeading>Parties</TitleHeading>
                                          <CardLine style={{ marginTop: "2%" }}>
                                            Associate Parties
                                          </CardLine>
                                          {individual?.parties?.map(
                                            (data, i) => (
                                              <Box flex={1} mb={2} key={i}>
                                                <Paragraph>
                                                  {data.name
                                                    ? data.name
                                                    : data?.first_name +
                                                      data?.last_name}
                                                  &nbsp;
                                                </Paragraph>
                                                <Flex gap="12">
                                                  <CardLine>
                                                    {data.email
                                                      ? data.email
                                                      : typeof data?.company_status ===
                                                        "object"
                                                      ? (
                                                          data?.company_status as any
                                                        )?.status || "-"
                                                      : data?.company_status ||
                                                        "-"}
                                                    &nbsp;
                                                  </CardLine>
                                                  <CardLine>
                                                    {data?._type === "entity"
                                                      ? data?.date_of_incorporation
                                                      : data?.date_of_birth}
                                                  </CardLine>
                                                </Flex>

                                                <Flex gap="24">
                                                  <Box flex={1}>
                                                    <CardLine>
                                                      {data?.address[0]
                                                        ?.flat_appartment_subbuilding && (
                                                        <span>
                                                          {
                                                            data?.address[0]
                                                              ?.flat_appartment_subbuilding
                                                          }
                                                          &nbsp;
                                                        </span>
                                                      )}
                                                      {data?.address[0]
                                                        ?.building_number && (
                                                        <span>
                                                          {
                                                            data?.address[0]
                                                              ?.building_number
                                                          }
                                                          &nbsp;
                                                        </span>
                                                      )}
                                                      {data?.address[0]
                                                        ?.building_name && (
                                                        <span>
                                                          {
                                                            data?.address[0]
                                                              ?.building_name
                                                          }
                                                          &nbsp;
                                                        </span>
                                                      )}
                                                      {
                                                        data?.address[0]
                                                          ?.road_street
                                                      }
                                                    </CardLine>
                                                    <CardLine>
                                                      {data?.address[0]
                                                        ?.town_city && (
                                                        <span>
                                                          {
                                                            data?.address[0]
                                                              ?.town_city
                                                          }
                                                          &nbsp;
                                                        </span>
                                                      )}
                                                      {
                                                        data?.address[0]
                                                          ?.district
                                                      }
                                                    </CardLine>
                                                    <CardLine>
                                                      {
                                                        data?.address[0]
                                                          ?.post_zip_code
                                                      }
                                                    </CardLine>
                                                  </Box>
                                                  <Box flex={1}>
                                                    <Flex
                                                      gap="8"
                                                      alignItems={"center"}
                                                      mb={1}
                                                      fontSize={1}
                                                      color="gray.60"
                                                      fontFamily={
                                                        "'Inter', sans-serif"
                                                      }
                                                    >
                                                      {data?.address[0]
                                                        ?.country_flag && (
                                                        <Box
                                                          backgroundColor={
                                                            "gray.10"
                                                          }
                                                          borderRadius={"50%"}
                                                          p={"1"}
                                                        >
                                                          <img
                                                            src={`data:image/png;base64,${data?.address[0]?.country_flag}`}
                                                            alt="iamge"
                                                          />
                                                        </Box>
                                                      )}
                                                      {data?.address[0]
                                                        ?.country_flag && (
                                                        <span>
                                                          &nbsp;
                                                          {
                                                            data?.address[0]
                                                              ?.country_name
                                                          }
                                                        </span>
                                                      )}
                                                    </Flex>
                                                  </Box>
                                                  <Box flex={1}>
                                                    {isProvided(
                                                      data?.address[0]
                                                        ?.date_from,
                                                    ) && (
                                                      <Box p={"1"}>
                                                        <CardLine>
                                                          From &nbsp;
                                                          {formatAddressDate(
                                                            data?.address[0]
                                                              ?.date_from,
                                                          )}
                                                          {isProvided(
                                                            data?.address[0]
                                                              ?.date_to,
                                                          ) && (
                                                            <>
                                                              &nbsp; to &nbsp;{" "}
                                                              {formatAddressDate(
                                                                data?.address[0]
                                                                  ?.date_to,
                                                              )}
                                                            </>
                                                          )}
                                                        </CardLine>
                                                      </Box>
                                                    )}
                                                  </Box>
                                                  <Box flex={1}></Box>
                                                </Flex>
                                                <hr></hr>
                                              </Box>
                                            ),
                                          )}
                                        </Box>
                                      ) : (
                                        <Paragraph fontSize={1} color="gray.60" my={0}>
                                          This section is not included in your
                                          application process.
                                        </Paragraph>
                                      )}
                                    </Flex>
                                  </div>
                                ),
                              },
                              {
                                label: "Forms",
                                content: (
                                  <ApplicationForms
                                    forms={individual?.forms}
                                    onRequestNew={() => setShowAddNewForm(true)}
                                  />
                                ),
                              },
                            ]}
                          />
  );
};
